import { requestAsync } from 'redux-query';
import auth from 'dash-front/auth';
import { UPDATE_DEFAULT } from 'dash-front/requery/actions';
import { toIdMap } from 'dash-front/helpers';
import cfg from 'cfg';

export const fetchAllCampaigns = () =>
    requestAsync({
        url: `${cfg.campaign_manager.host}/api/campaigns-list?access_token=${auth.getAccessToken()}`,
        queryKey: 'GET:campaigns-list',
        transform: data => ({
            campaignsList: toIdMap(data)
        }),
        force: true,
        update: {
            campaignsList: UPDATE_DEFAULT.MERGE
        }
    });



/** WEBPACK FOOTER **
 ** ../src/dash/front/admin/actions/campaigns.js
 **/